import script from "./AnalyticsPolygonInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsPolygonInfo.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsPolygonInfo.vue?vue&type=style&index=0&id=5935f7d6&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5935f7d6"]])

export default __exports__